import { render, staticRenderFns } from "./firstClassPage.vue?vue&type=template&id=0fed0398&scoped=true&"
import script from "./firstClassPage.vue?vue&type=script&lang=js&"
export * from "./firstClassPage.vue?vue&type=script&lang=js&"
import style0 from "./firstClassPage.vue?vue&type=style&index=0&id=0fed0398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed0398",
  null
  
)

export default component.exports